module.exports = __webpack_public_path__ + "static/media/efu.b20f0c34.png";